"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtocolViewer__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_tokenAddresses",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_ownerAddresses",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_spenderAddresses",
                type: "address[]",
            },
        ],
        name: "batchFetchAllowances",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_tokenAddresses",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_ownerAddresses",
                type: "address[]",
            },
        ],
        name: "batchFetchBalancesOf",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken[]",
                name: "_setTokens",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_moduleList",
                type: "address[]",
            },
        ],
        name: "batchFetchDetails",
        outputs: [
            {
                components: [
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "symbol",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "manager",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "modules",
                        type: "address[]",
                    },
                    {
                        internalType: "enum ISetToken.ModuleState[]",
                        name: "moduleStatuses",
                        type: "uint8[]",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "component",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "module",
                                type: "address",
                            },
                            {
                                internalType: "int256",
                                name: "unit",
                                type: "int256",
                            },
                            {
                                internalType: "uint8",
                                name: "positionState",
                                type: "uint8",
                            },
                            {
                                internalType: "bytes",
                                name: "data",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct ISetToken.Position[]",
                        name: "positions",
                        type: "tuple[]",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                ],
                internalType: "struct SetTokenViewer.SetDetails[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken[]",
                name: "_setTokens",
                type: "address[]",
            },
        ],
        name: "batchFetchManagers",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken[]",
                name: "_setTokens",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_modules",
                type: "address[]",
            },
        ],
        name: "batchFetchModuleStates",
        outputs: [
            {
                internalType: "enum ISetToken.ModuleState[][]",
                name: "",
                type: "uint8[][]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStreamingFeeModule",
                name: "_streamingFeeModule",
                type: "address",
            },
            {
                internalType: "contract ISetToken[]",
                name: "_setTokens",
                type: "address[]",
            },
        ],
        name: "batchFetchStreamingFeeInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "feeRecipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "streamingFeePercentage",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "unaccruedFees",
                        type: "uint256",
                    },
                ],
                internalType: "struct StreamingFeeModuleViewer.StreamingFeeInfo[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_moduleList",
                type: "address[]",
            },
        ],
        name: "getSetDetails",
        outputs: [
            {
                components: [
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "symbol",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "manager",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "modules",
                        type: "address[]",
                    },
                    {
                        internalType: "enum ISetToken.ModuleState[]",
                        name: "moduleStatuses",
                        type: "uint8[]",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "component",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "module",
                                type: "address",
                            },
                            {
                                internalType: "int256",
                                name: "unit",
                                type: "int256",
                            },
                            {
                                internalType: "uint8",
                                name: "positionState",
                                type: "uint8",
                            },
                            {
                                internalType: "bytes",
                                name: "data",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct ISetToken.Position[]",
                        name: "positions",
                        type: "tuple[]",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                ],
                internalType: "struct SetTokenViewer.SetDetails",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
var ProtocolViewer__factory = /** @class */ (function (_super) {
    __extends(ProtocolViewer__factory, _super);
    function ProtocolViewer__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ProtocolViewer__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ProtocolViewer__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ProtocolViewer__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ProtocolViewer__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ProtocolViewer__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    ProtocolViewer__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    ProtocolViewer__factory.bytecode = _bytecode;
    ProtocolViewer__factory.abi = _abi;
    return ProtocolViewer__factory;
}(ethers_1.ContractFactory));
exports.ProtocolViewer__factory = ProtocolViewer__factory;
//# sourceMappingURL=ProtocolViewer__factory.js.map